import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "component/ui/Dropdown";
import { useTour } from "@reactour/tour";
import { FinanceProcess } from "asset/icons";
import { Button } from "component/ui/Button";
import React from "react";
import { Modal } from "react-bootstrap";

const StartTourModal = ({
    show,
    onHide,
    handleCancelWalkThrough,
    isCancelingWalkThroughLoading,
}) => {
    const { setIsOpen } = useTour();
    const handleCancelWalkThroughClick = async () => {
        await handleCancelWalkThrough();
        onHide();
    };
    const handleSkipForNow = () => {
        window.localStorage.setItem("financeTourSkipped", "true");
        onHide();
    };
    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="border-0 "
            onHide={() => onHide}
        >
            <Modal.Body
                style={{
                    borderRadius: "16px",
                    padding: "0px",
                    border: "none",
                }}
            >
                <div className="flex flex-col items-center justify-center p-4">
                    <FinanceProcess />

                    <h5 className="text-2xl font-semibold text-center text-main-dark">
                        Let’s walk you through <br /> our finance module
                    </h5>
                    <p className="text-[#383B56] text-center text-base font-light">
                        We’ve improved how you request loans <br /> and access credit on the
                        platform
                    </p>
                </div>
                <div
                    style={{ borderTop: "1px solid #E7E9FB" }}
                    className="flex items-center justify-between p-4"
                >
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button
                                disabled={isCancelingWalkThroughLoading}
                                size="sm"
                                variant="ghost"
                                className="bg-[#F3F4FB]"
                            >
                                Skip
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent
                            className={`bg-white z-[2000] h-full w-[120px] flex flex-col items-center justify-center shadow-none rounded-xl p-1 overflow-hidden border border-[#E6E8F9]`}
                            align="start"
                        >
                            <Button
                                disabled={isCancelingWalkThroughLoading}
                                size="sm"
                                variant="ghost"
                                onClick={handleSkipForNow}
                            >
                                Skip for now
                            </Button>
                            <Button
                                disabled={isCancelingWalkThroughLoading}
                                size="sm"
                                variant="ghost"
                                onClick={handleCancelWalkThroughClick}
                            >
                                Skip forever
                            </Button>
                        </DropdownMenuContent>
                    </DropdownMenu>

                    <Button
                        onClick={() => {
                            setIsOpen(true);
                            onHide();
                        }}
                        size="sm"
                        disabled={isCancelingWalkThroughLoading}
                    >
                        Take tour
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default StartTourModal;
